export const locale = {
    lang: 'cs',
    data: {
        TOOLBAR: {
            MY_PROFILE: 'Můj profil',
            PORTAL: 'Rozcestník',
            LOGOUT: 'Odhlásit',
        }
    }
};
